import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import { AiFillBug } from "react-icons/ai";

function List() {
    let path = '/core/examples/crud/frontend/';
    let list = {
        labelTitle: 'Lista de aplicações',
        pathAdd: path+'add',
        pathEdit: path+'edit',
        pathView: path+'view',
        pathDelete: path+'delete',
        fieldsShowOnDelete: ['application_name'],
        showPrintButtons: true,
        truncateTextSize: 50,
        columns: [
            {
                name: 'application_name',
                label: 'Aplicação',
                width: '80%'
            }
        ],
        rows :[
            { id: 1, application_name : 'O width esta configurado em 80% Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s' },
            { id: 2, application_name : 'APP 2' },
            { id: 3, application_name : 'APP 3' },
            { id: 4, application_name : 'APP 4' },
        ]
    };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                icon={<AiFillBug size={20}/>}
                content={<CustomList list={list} />}
            />
            
        </div>
    );
}
export default List;
